<template>
  <div
    class="mime_split"
    v-loading="loading || submitLoading"
    element-loading-text="系统识别中"
  >
    <div class="main clearfix">
      <div class="pull-left split-main">
        <div class="split-meau fix">
          <div
            class="mask"
            v-if="notEdit"
          ></div>
          <div
            class="notice"
            v-if="lostArr.length > 0"
          >
            <span>提示: 遗漏<em class="red">{{ lostArr.length }}</em>题，题号为</span>{{ lostArr.join(',') }}
          </div>
          <div
            class="red"
            @click="undoSplit"
          >
            <i class="el-icon-refresh"></i>还原试卷
          </div>
          <div
            class="red"
            @click="doClearSplit"
          >
            <i class="icon iconfont icon-znjf-qingchuhuaquhenji"></i>清除划题痕迹
          </div>
          <div
            class="green"
            @click="editPaper"
          >
            <i class="icon iconfont icon-znjf-edit"></i>编辑试卷
          </div>
          <div
            class="green"
            @click="doSplitConform"
          >
            <i class="icon iconfont icon-znjf-zhongxinshibie"></i>重新识别
          </div>
        </div>
        <div
          v-if="htmlStr"
          class="split-wrap"
        >
          <editorHtml
            id="splitHtmlEditor"
            ref="splitHtmlEditor"
            v-model="htmlStr"
            :editablePaper="editablePaper"
            @close="closeEditPaper"
            @save="saveEditPaper"
            @preview="clickQuestion"
            @cancle="clearSingleSplit"
            @divide="doSplitSingle"
            @showRule="showRule"
          ></editorHtml>
        </div>
        <c-no-data
          v-if="!htmlStr"
          txt="拆解任务正在解析生成中..."
          :extraStyle="{
            'padding-top': '200px'
          }"
        >
        </c-no-data>
      </div>
      <div
        class="pull-right tag-main"
        v-if="questionList.length > 0"
      >
        <div class="question">
          <div class="title">
            <span>共划{{ questionList.length }}题：已完成<em class="green">{{ doneNum }}</em>题，待完成<em class="red">{{ undoNum }}</em>题</span>
            <!-- <span
              class="green pointer"
              @click="questionNumVisible = true"
            ><i class="icomoon-xtsz"></i>设置教辅题号分数</span> -->
          </div>
          <div class="num-list">
            <span
              v-for="(item, index) in questionList"
              :key="index"
              class="num-item"
              :class="curQuestionIndex === index ? 'active status-' + item.status : 'status-' + item.status"
              @click="changeQuestion(index)"
            >
              {{ index + 1}}
            </span>
          </div>
        </div>
        <div
          class="question-tag"
          v-scrollbar="'tag-wrap'"
        >
          <div
            class="mask"
            v-if="notEdit"
          ></div>
          <div class="tag-wrap">
            <div
              class="mask"
              v-if="notEdit"
            ></div>
            <question-edit
              v-model="curQuestion"
              :curStep="curQuestionIndex"
              @save="nextQuestion"
              @changStruct="changStruct"
              :notEdit="notEdit"
              :scoreCheck="false"
              ref="questionEdit"
              page="split"
            ></question-edit>
          </div>
        </div>
      </div>
      <div
        class="pull-right tag-main"
        v-else
      >
        <c-no-data
          txt="请先框选题目进行划题~"
          :extraStyle="{
            'padding-top': '100px'
          }"
        >
        </c-no-data>
      </div>
    </div>

    <setTagDialog
      v-model="tagVisible"
      :tag-info="tagInfo"
      @setTag="setTag"
    >
    </setTagDialog>

    <editRuleDialog v-model="ruleVisible"></editRuleDialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { deepClone, isEmpty, newGuid } from "@/utils/tools";
import splitMixins from "./mixins/splitMixins";
import CNoData from "./components/CNoData";

// const appDomain = location.origin.includes('jkxjxw') ? "https://test-pad.forclass.net" : "http://127.0.0.1:5500";

let appDomain;

const ALLOWED_ORIGINS = [
  'https://test-pad.forclass.net',      // A生产环境
  'http://127.0.0.1:5500',   // A本地开发环境
];

const loadScript = (url) => {
  return new Promise((resolve, reject) => {
    var script = document.createElement("script");
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export default {
  name: "mimeSplit",
  mixins: [splitMixins],
  computed: {
    notEdit() {
      return false;
    },
  },
  created() {
    // 在进入页面之前，设置 body 的宽高为 100%
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy () {
    document.body.style.width = '';
    document.body.style.height = '';
    document.body.style.overflow = '';
  },
  components: {
    CNoData,
  },
  created() {
    loadScript(
      "https://jty-open-new.obs.cn-north-4.myhuaweicloud.com/tinymce/tinymce4.9.11/tinymce.min.js"
    );
    // loadScript('/static/htmlSplit.js');
  },
  data() {
    return {
      loading: false,
      splitPage: "sm",
      paperId: "",
      stageId: "",
      subjectId: "",
    };
  },
  async mounted() {
    console.log('initSplitHtml');
    this.loading = true;
    this.callParentMethod('initSplitHtml', 'start')
    // 监听父页面消息
    window.addEventListener("message", this.handleParentMessage);
  },
  beforeDestroy() {
    // 清理监听避免内存泄漏
    window.removeEventListener("message", this.handleParentMessage);
  },
  methods: {
    handleParentMessage(event) {
      console.log(event);
      if (appDomain && event.origin !== appDomain) return;
      // if (!ALLOWED_ORIGINS.includes(event.origin)) return;
      !appDomain && (appDomain = event.origin)
      const { method, params } = event.data;
      if (method === "postSplitInfo") {
        // 发送响应
        event.source.postMessage(
          {
            method: `${method}Response`,
            result: "开始拆解",
          },
          event.origin
        );
        this.startSplit(params);
      } else if (method === "doSavePaper") {
        this.doSavePaper();
      } else if (method === "doSubmitPaper") {
        this.doSubmitPaper();
      }
    },
    callParentMethod(methodName, result, callback) {
      const message = { method: methodName, result };
      window.parent.postMessage(message, appDomain || '*');
    },
    startSplit(params) {
      let {
        questionJson,
        originHtmlContent,
        htmlContent,
        difficultList,
        knowledgePointList,
        questionTypeList,
        paperId,
        stageId,
        stageName,
        subjectId,
        subjectName,
      } = params;
      this.paperId = paperId;
      this.stageId = stageId;
      this.stageName = stageName;
      this.subjectId = subjectId;
      this.subjectName = subjectName;
      this.getQuestionTypeList(questionTypeList);
      this.getBasicKnowledgePointList(knowledgePointList);
      this.getDifficultList(difficultList);
      setTimeout(() => {
        if (!this.basicQuestionType || this.basicQuestionType.length === 0) {
          this.$message.error("无可拆解题型，请配置题型结构");
        }
        loadScript("/static/htmlSplit.js")
          .then(() => {
            this.splitApp = new htmlSplit();
            this.initSplit(this.subjectName);
            this.getSplitDetail({
              questionJson,
              originHtmlContent,
              htmlContent,
            });
          })
          .catch((error) => {
            console.log(error);
            this.$message.error("试卷拆解转换失败，请刷新重试");
          });
      }, 500);
    },
    // clickClose() {
    //   this.goBack();
    // },
    // async clickSubmitBack() {
    //   await this.setSplitHtml();
    //   this.goBack();
    // },
    clickSubmitQuestionNum(qList) {
      this.questionList = qList;
      let index = this.curQuestionIndex;
      this.curQuestion = this.questionList[index];
      this.setLeftQuestionNum();
    },
    // 切题
    changeQuestion(index) {
      this.clickQuestion(index, true);
    },
    async clickQuestion(index, isJump = false) {
      // 先校验下前一道题
      let isVaild = this.$refs.questionEdit.checkForm();

      if (isVaild) {
        this.curQuestion["status"] = 1;
      } else {
        this.curQuestion["status"] = 0;
      }
      // 重新计算下当前单题的题号
      this.refreshQuestionNum(this.curQuestion, this.curQuestionIndex);
      // 先保存下单题
      await this.doSaveSinglePaper(this.curQuestion);
      if (index === 999999) {
        return
      }
      // 在跳转
      setTimeout(() => {
        this.curQuestionIndex = index;
        let lastQuestion = deepClone(this.curQuestion);
        let curQuestion = this.questionList[index];
        // todo 记忆下难度知识点
        // if (!curQuestion.questionTag.questionDifficultId) {
        //   curQuestion.questionTag.questionDifficultId = lastQuestion.questionTag.questionDifficultId || ''
        // }
        // if (!curQuestion.questionTag.knowledgePoints || curQuestion.questionTag.knowledgePoints.length === 0) {
        //   curQuestion.questionTag.knowledgePoints = lastQuestion.questionTag.knowledgePoints || []
        // }
        this.curQuestion = curQuestion;

        let el = document.getElementsByClassName("qArea")[index];
        if (isJump && el) {
          let offsetTop = el.offsetTop - 50 > 0 ? el.offsetTop - 50 : 0;
          document
            .getElementsByClassName("scroll-box")[0]
            .scrollTo(0, offsetTop);
        }
      }, 10);
      // 切换题重新渲染左侧题号
      this.setLeftQuestionNum();
    },
    async nextQuestion(index) {
      // 切小题，也要保存
      if (index === 999999) {
        this.clickQuestion(999999, true);
        return
      }
      if (index < this.questionList.length - 1) {
        this.clickQuestion(index + 1, true);
      } else {
        this.clickQuestion(0, true);
      }
    },
    getSplitDetail(obj) {
      this.loading = true;
      let { originHtmlContent, htmlContent, questionJson } = obj;

      this.originHtmlContent = originHtmlContent;
      if (questionJson) {
        questionJson = JSON.parse(questionJson);
      }
      // 保存过一次后，就不用自动拆解的
      if (questionJson && questionJson.length === 0) {
        this.htmlStr = htmlContent;
        this.questionList = questionJson;
        this.curQuestionIndex = -1;
        this.curQuestion = {};
        this.loading = false;
        this.setLeftQuestionNum();
        return;
      }
      if (questionJson && questionJson.length > 0) {
        this.htmlStr = htmlContent;
        this.questionList = questionJson;
        this.curQuestionIndex = 0;
        this.curQuestion = this.questionList[0];
        this.loading = false;
        this.setLeftQuestionNum();
        return;
      }
      // 第一次，没有题，自动拆解(初高中英语不自动拆解)
      this.htmlStr = originHtmlContent;
      let map = {
        12: '英语',
        28: '英语'
      }
      if (map[this.subjectId] === '英语') {
        this.loading = false;
        this.clearSplit();
        return
      }
      this.doSplit();
      this.loading = false;
    },
    // 保存html
    async setSplitHtml() {
      if (this.notEdit) {
        return;
      }
      // 暂存的
      questionList = deepClone(this.questionList);
      let qNumber = 1;
      let questionList = questionList.map((item, index) => {
        item.id = "";
        // 统一处理选项
        if (![1, 2, 6].includes(+item.structId)) {
          item.options = null;
        } else {
          item.options = !isEmpty(item.options) ? item.options : null;
        }
        // 统一填空题
        // if (+item.structId === 4 && item.children) {
        //   item.answer = item.children.map(item => item.answer).join('#@#')
        // }
        if (+item.structId === 7 && item.children) {
          item.children = item.children.map((citem, cindex) => {
            // citem.answer = ""
            // citem.analysis = ""
            citem.options = !isEmpty(citem.options) ? citem.options : null;
            if (citem.children) {
              delete citem.children;
            }
            return citem;
          });
          item.answer = "";
          item.options = null;
        }
        if (+item.structId === 7 && !item.children) {
          item.children = [];
        }
        if (+item.structId === 8 && item.children) {
          item.children = item.children.map((citem, cindex) => {
            citem.options = !isEmpty(citem.options) ? citem.options : null;
            return citem;
          });
          item.answer = "";
          item.options = null;
        }
        if (+item.structId === 8 && !item.children) {
          item.children = [];
        }
        // 统一处理小题
        if (![4, 7, 8].includes(+item.structId)) {
          item.children = [];
        }
        if (![7, 8].includes(+item.structId)) {
        } else {
          if (!isEmpty(item.children)) {
            item.children = item.children.map((citem) => {
              return {
                ...citem,
                id: "",
              };
            });
          }
        }
        return item;
      });

      this.callParentMethod('setSplitHtmlAndJson', {
        id: this.paperId,
        html: document.getElementById("splitHtmlEditor").innerHTML,
        questionJson: JSON.stringify(questionList),
      });
    },
    // 提交试卷
    async doSubmitPaper() {
      if (this.submitLoading) {
        this.callParentMethod('setVaildError', "操作太快了")
        return;
      }
      if (this.notEdit) {
        this.callParentMethod('setVaildError', "请退出编辑")
        return;
      }
      this.submitLoading = true;
      if (this.questionList.length === 0) {
        this.$message.error("至少拆解一道题!");
        this.submitLoading = false;
        this.callParentMethod('setVaildError', "至少拆解一道题!")
        return;
      }
      for (let i = 0; i < this.questionList.length; i++) {
        // 试题的状态 0, 1,3,4,5,6,7 待拆解，已拆解,拆解审核拒绝，拆解审核通过，已打标，打标审核拒绝，打标审核通过
        if (![1, 4].includes(this.questionList[i].status)) {
          let text = this.createReason();
          this.$message.error("存在必填项未填写!");
          this.callParentMethod('setVaildError', "存在必填项未填写!")
          this.submitLoading = false;
          return;
        }
      }
      try {
        // 存库的
        let questionList1 = deepClone(this.questionList);
        questionList1 = questionList1.map((item, index) => {
          item.stageId = this.stageId;
          item.subjectId = this.subjectId;
          item.questionDifficultId = item.questionTag.questionDifficultId;
          item.knowledgePoints = item.questionTag.knowledgePoints;
          // 统一处理选项
          if (![1, 2, 6].includes(+item.structId)) {
            item.options = null;
          } else {
            item.options = !isEmpty(item.options) ? item.options : null;
          }
          // 统一填空题
          if (+item.structId === 4 && item.children) {
            item.answer = item.children.map((item) => item.answer).join("#@#");
          }
          if (+item.structId === 7 && item.children) {
            item.children = item.children.map((citem, cindex) => {
              citem.options = !isEmpty(citem.options) ? citem.options : null;
              if (citem.children) {
                delete citem.children;
              }
              return citem;
            });
            item.answer = "";
            item.options = null;
          }
          if (+item.structId === 7 && !item.children) {
            item.children = [];
          }
          if (+item.structId === 8 && item.children) {
            item.children = item.children.map((citem, cindex) => {
              if (+citem.structId === 4 && citem.children) {
                citem.answer = citem.children
                  .map((aitem) => aitem.answer)
                  .join("#@#");
              }
              citem.options = !isEmpty(citem.options) ? citem.options : null;
              if (citem.children) {
                delete citem.children;
              }
              return citem;
            });
            item.answer = "";
            item.options = null;
          }
          if (+item.structId === 8 && !item.children) {
            item.children = [];
          }
          // 统一处理小题
          if (![7, 8].includes(+item.structId)) {
            item.children = [];
          } else {
            if (!isEmpty(item.children)) {
              item.children = item.children.map((citem) => {
                return {
                  analysis: citem.analysis,
                  answer: citem.answer,
                  collect: false,
                  documentId: +this.paperId,
                  knowledgePoints: item.knowledgePoints, // 用父的
                  options: citem.options,
                  paperSetting: false,
                  questionDifficultId: item.questionDifficultId, // 用父的
                  questionNumber: citem.questionNumber,
                  questionTypeId: citem.questionTypeId,
                  score: citem.score,
                  stageId: item.stageId, // 用父的
                  stem: citem.stem,
                  subjectId: item.subjectId, // 用父的
                  upload: true,
                  origin: 0,
                };
              });
            }
          }
          delete item.questionTag;
          return {
            analysis: item.analysis,
            answer: item.answer,
            collect: false,
            documentId: +this.paperId,
            knowledgePoints: item.knowledgePoints,
            options: item.options,
            paperSetting: false,
            questionDifficultId: item.questionDifficultId,
            questionNumber: item.questionNumber,
            questionTypeId: item.questionTypeId,
            score: item.score,
            stageId: item.stageId,
            stem: item.stem,
            subjectId: item.subjectId,
            upload: true,
            children: item.children,
            origin: 0,
          };
        });
        // 先清空题(只拆一次不用清空也行)
        this.callParentMethod('clearSplitAllQuestion', this.paperId);
        // 再保存试题(后端一个事务保存)
        this.callParentMethod('setSplitQuestion', questionList1)
        // 保存html
        this.setSplitHtml();
        this.submitLoading = false;
      } catch (error) {
        this.submitLoading = false;
        this.$message.error("提交失败!");
        console.log(error);
      }
    },
    // 生成异常原因
    createReason() {
      let reason = [];
      this.questionList.forEach((item, index) => {
        if (![1, 4].includes(this.questionList[index].status)) {
          reason.push(`第${index + 1}题存必填项未填写`);
        }
      });
      return reason.join("\r\n");
    },
    // 保存试卷
    async doSavePaper() {
      this.setSplitHtml();
      // this.$message.success("保存成功!");
    },
    // 保存单道题（保存html和拆出来的题）
    async doSaveSinglePaper() {
      this.setSplitHtml();
    },
    async changStruct(stepStruct) {
      console.log('换结构', stepStruct);
      let step = +stepStruct.split('-')[0]
      let struct = +stepStruct.split('-')[1]
      let questionTypeId = +stepStruct.split('-')[2]
      let el = document.getElementsByClassName("qArea")[step];
      let cloneEl = el.cloneNode(true)
      cloneEl.removeAttribute("data-type");
      cloneEl.removeAttribute("data-struct");
      $(cloneEl).find(".question-number").remove();
      // 获取 div 内的所有 p 元素
      const paragraphs = Array.from(cloneEl.childNodes);
      // 在 div 前插入所有 p 元素
      paragraphs.forEach((p) => {
        if (p && p.nodeName === "P") {
          p.removeAttribute("data-filed");
          p.removeAttribute("data-splitid");
          p.innerHTML = p.innerHTML.replace(/<mark>【选项】<\/mark>/g, '').replace(/<mark>【小题选项】<\/mark>/g, '')
          p.innerHTML = p.innerHTML.replace(/<bdo[^>]*?code="(.+?)"[^>]*?>.*?<\/bdo>/g, ($1, $2) => {
            return decodeURIComponent(atob($2))
          })
        }
      });
      let htmlStr = cloneEl.innerHTML
      let splitObj = this.splitApp.setHtmlStr(htmlStr).startSplit(questionTypeId);
      if (splitObj.outputList.length === 0) {
        return;
      }
      this.curQuestionIndex = -1
      this.curQuestion = {}
      const parser = new DOMParser();
      const doc = parser.parseFromString(splitObj.outputHtml, "text/html");
      el.parentNode.insertBefore(doc.body.childNodes[0], el);
      el.parentNode.removeChild(el);
      // 还原下题号
      let obj = this.questionList[step]
      let start = obj.orderNumber
      if (obj.children && obj.children.length > 0 && [7, 8].includes(struct)) {
        start = item.children[0].orderNumber
      }
      let questionList = await this.dealSplitList(splitObj.outputList, questionTypeId, start)
      this.$set(this.questionList, step, questionList[0])
      setTimeout(() => {
        this.curQuestionIndex = step
        this.curQuestion = questionList[0];
        this.setLeftQuestionNum()
      }, 0);
    },
    // 关闭函数(退出拆解)
    goBack() {
      window.history.length > 2
        ? this.$router.go(-1)
        : this.$router.push({
            name: "myPaper",
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.mime_split {
  .fix {
    position: fixed;
  }
  .header {
    position: fixed;
    width: 100%;
    top: 0;
    height: 88px;
    padding: 0 16px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f7f8fa;
    z-index: 999;

    .task-back {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 480px;
      flex-shrink: 0;
    }

    .task-title {
      width: calc(100% - 300px);
      line-height: 22px;
      font-weight: bold;
      font-size: 16px;
      color: #1d2129;
      text-align: center;
    }

    .task-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 480px;
      flex-shrink: 0;
    }
  }
  .main {
    // margin-top: 104px;
    overflow-x: hidden;
    display: flex;

    .split-main {
      position: relative;
      min-width: 0;
      height: 100vh;
      padding-top: 68px;
      box-sizing: border-box;
      // width: calc(100% - 512px);
      flex-grow: 1;
      flex-shrink: 1;
      background: #ffffff;
      margin: 0 0 0 16px;
      border-radius: 8px;

      .split-meau {
        padding: 0 16px;
        height: 68px;
        top: 0;
        left: 16px;
        width: calc(100% - 496px);
        border-bottom: 1px solid #f7f8fa;
        // border-top: 16px solid #ffffff;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1333;
          cursor: not-allowed;
        }

        div {
          margin-left: 16px;
          cursor: pointer;

          i {
            color: inherit;
            margin-right: 4px;
            font-size: 16px;
            vertical-align: middle;
          }
        }

        div.notice {
          position: absolute;
          height: 64px;
          left: 0px;
          top: 0px;
          max-width: 600px;
          word-wrap: break-word;
          display: flex;
          align-items: center; /* 垂直居中 */
          flex-wrap: wrap;
          justify-content: flex-start;
          font-size: 13px;

          em {
            font-style: normal;
          }
        }
      }

      .split-wrap {
        padding: 40px 8px 0px 86px;
      }
    }

    .tag-main {
      width: 480px;
      height: 100vh;
      background: #ffffff;
      border-left: 1px solid #f7f8fa;
      box-sizing: border-box;
      flex-shrink: 0;
      flex-grow: 0;
      display: flex;
      flex-direction: column;
      box-shadow: 0 8px 20px 0 rgba($color: #000000, $alpha: 0.1);
      z-index: 9;

      .question {
        right: 0;
        top: 104px;
        width: 480px;
        min-height: 0;
        border-bottom: 1px solid #f7f8fa;
        padding: 16px 24px 20px 24px;
        box-sizing: border-box;
        background: #fff;
        z-index: 999;
        flex-grow: 1;
        flex-shrink: 0;

        div.title {
          display: flex;
          justify-content: space-between;
          line-height: 20px;

          span {
            color: #1d2129;
            line-height: 20px;

            i {
              color: inherit;
              margin-right: 4px;
              font-size: 16px;
              vertical-align: text-bottom;
            }

            em {
              font-style: normal;
              margin: 0 1px;
            }
          }
        }

        div.num-list {
          padding: 32px 20px 0 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;

          span.num-item {
            display: block;
            width: 28px;
            height: 28px;
            background: #fff;
            border-radius: 4px;
            margin-right: 12px;
            margin-bottom: 12px;
            text-align: center;
            line-height: 26px;
            box-sizing: border-box;
          }

          span.num-item:nth-of-type(10n) {
            margin-right: 0px;
          }

          span.status-0 {
            color: #f53f3f;
            border: 1px solid #f53f3f;
          }

          span.status-1 {
            color: #0ea980;
            border: 1px solid #0ea980;
          }

          span.status-3 {
            color: #f53f3f;
            border: 1px solid #f53f3f;
          }

          span.status-4 {
            color: #0ea980;
            border: 1px solid #0ea980;
          }

          span.status-0.active,
          span.status-3.active {
            background: #f53f3f;
            color: #fff;
            border: 1px solid #f53f3f;
          }

          span.status-1.active,
          span.status-4.active {
            background: #0ea980;
            color: #fff;
            border: 1px solid #0ea980;
          }
        }
      }

      .question-tag {
        position: relative;
        height: calc(100vh - 66px);
        flex-shrink: 1;

        .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1333;
          cursor: not-allowed;
        }

        .tag-wrap {
          position: relative;
        }

        div.check-info {
          height: 40px;
          background: #ffece8;
          border: 1px solid #f53f3f;
          border-radius: 4px;
          text-align: center;
          line-height: 38px;
          color: #f53f3f;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 12px;
          box-sizing: border-box;
          margin: 0 16px;

          p {
            color: #1d2129;

            span {
              margin: 0 8px;
              font-weight: bold;
            }

            i {
              color: #f53f3f;
              font-size: 16px;
              vertical-align: text-bottom;
            }
          }
        }

        div.check-info.green {
          background: #e8ffea;
          color: #0ea980;
          border: 1px solid #0ea980;

          p {
            i {
              color: #0ea980;
              font-size: 16px;
              vertical-align: text-bottom;
            }
          }
        }
      }

      .repeat-notice {
        position: relative;
        margin: 16px auto 13px auto;
        width: 448px;
        height: 67px;
        background: #fffde8;
        border: 1px solid #fbdf5f;
        border-radius: 4px;
        padding: 11px 0 0 13px;
        z-index: 1334;

        p {
          font-size: 14px;
          color: #1d2129;
          letter-spacing: 0;
          line-height: 22px;

          i {
            font-size: 17px;
            color: #f9bc06;
            margin-right: 4px;
            vertical-align: text-bottom;
            font-size: 16px;
          }
        }

        span {
          margin: 4px 0 0 22px;
          font-size: 14px;
          color: #f9bc06;
          line-height: 22px;
          cursor: pointer;
        }
      }

      .repeat-notice-done {
        background: #e8ffea;
        border: 1px solid #0ea980;

        p {
          i {
            color: #0ea980;
            font-size: 16px;
            vertical-align: text-bottom;
          }
        }

        span {
          color: #0ea980;
        }
      }
    }

    .red {
      color: #f53f3f !important;
    }

    .green {
      color: #0ea980 !important;
    }
  }
}
</style>

<style lang="scss">
.mime_split {
  mark {
    background: #ff0;
    font-style: normal;
  }
  .tag-main {
    .question-tag {
      position: relative;

      div.check-info {
        .el-checkbox {
          color: inherit;
        }
        .el-checkbox__label {
          color: #1d2129;
        }
      }

      .ps__rail-y {
        opacity: 1 !important;

        .ps__thumb-y {
          background: #e8ffea;
          width: 8px;
        }
      }

      .ps__rail-y:hover {
        opacity: 1 !important;
        background: transparent;
      }
    }
  }

  .split-main {
    .split-wrap {
      height: calc(100vh - 180px);
    }
  }
  .el-tag {
    background-color: rgb(230.9, 246.4, 242.3);
    border-color: rgb(206.8, 237.8, 229.6);
    color: #0EA980;
  }
  .el-tag .el-tag__close {
    color: #0EA980;
  }
  .el-tag .el-tag__close:hover {
    background: #0EA980;
    color: #fff;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #0EA980;
    background: #0EA980;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #0EA980;
    border-color: #0EA980;
  }
  .el-loading-spinner .path {
    stroke: #0EA980;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color: #0EA980;
  }
  .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #0EA980;
  }
  .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
    border-color: #0EA980;
  }
}

.el-select-dropdown__item.selected {
  color: #0EA980;
}
</style>



// WEBPACK FOOTER //
// src/pages/htmlSplit/split.vue